module.exports = __webpack_public_path__ + "static/media/moduleSet_i0o1.b2b68f7a.jpg";